import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';

const state = {
    /* Registro */
    retencionesRegimenes: [],
    /* Opciones de filtro y paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    nombre: '',
    incluirInactivos: false,

    list: [],
    selectList: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.retencionesRegimenes = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.nombre = '';
        state.incluirInactivos = false;
    },

    'INICIALIZAR'(state) {
        state.retencionesRegimenes = [];
    },
    'SET_RETENCIONES_REGIMENES'(state, retencionesRegimenes) {
        state.retencionesRegimenes = retencionesRegimenes;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_SELECT_LIST'(state) {
        state.list = [];
        state.selectList = [];
    },
    'SET_SELECT_LIST'(state, params) {
        state.list = params.list;
        state.selectList = params.selectList;
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getRetencionesRegimenes: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR')

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;
            
            apiAxios.get('retencionesregimenes' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        let params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_RETENCIONES_REGIMENES', res.data)

                    resolve();
                })
                .catch(error => reject(error))
            }, error => {
                reject(error);
            })
    },

    getList: ({commit}, retencionTipoId) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_SELECT_LIST');

            apiAxios.get('retencionesregimenes/list/' + retencionTipoId)
                .then(res => {
                    let selectList = [];
                    res.data.forEach(retencionRegimen => {
                        selectList.push(retencionRegimen.nombre.trim())
                    });
                    let params = {
                        list: res.data,
                        selectList
                    }
                    //console.log(params);
                    commit('SET_SELECT_LIST', params);
                    resolve();
                })
                .catch(error => reject(error) )
            }, error => {
                reject(error);
            })
    },

};

const getters = {
    getField,

    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}